import React, { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import FormattedCurrency from 'js/components/FormattedCurrency'

type Props = {
  discount: number
  discountOnlyFirstPurchase: boolean
  originalPrice: number
  currency: string
  price: number
  isFallbackPrice: boolean
  duration: number
  durationText?: ReactElement
}

const ChooseSubscriptionText = ({
  duration,
  durationText,
  discount,
  currency,
  price,
  isFallbackPrice,
}: Props) => (
  <div>
    <div className="lg:justify-left flex items-center capitalize type-12-bold lg:static lg:type-17-demibold">
      {duration}&nbsp;
      {duration === 1 ? (
        <FormattedMessage id="Redeem.plans.month" defaultMessage="Month" />
      ) : (
        <FormattedMessage id="Redeem.plans.months" defaultMessage="Months" />
      )}
    </div>
    {discount > 0 && (
      <div className="mt-6 font-demibold type-28-bold lg:mt-0 lg:type-32-bold">
        <FormattedCurrency value={price} currency={currency} />
      </div>
    )}
    {isFallbackPrice && (
      <span className="hidden lg:block">
        <FormattedMessage
          id="chooseSubscription.regularPrice"
          defaultMessage="Regular price"
        />
      </span>
    )}
    <div className="type-small text-TypeSub text-black lg:hidden">
      {durationText}
    </div>
  </div>
)

export default ChooseSubscriptionText
